export const SET_DEVICE = 'SET_DEVICE';
export const SET_WIDTH = 'SET_WIDTH';
export const SET_ORIENTATION = 'SET_ORIENTATION';
